import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ConfigService } from 'src/app/core/service/config.service';
import { CreateAuctionComponent } from 'src/app/features/rooms/component/createAuction/createAuction.component';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { ConfirmComponent } from 'src/app/shared/actions/delete/confirm.component';
import { StartAuctionComponent } from './start-auction/start-auction.component';
import { EndAuctionComponent } from './end-auction/end-auction.component';
import { ChangeStatusComponent } from './change-status/change-status.component';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { AuctionEndedPopUpComponent } from '../auction-ended-pop-up/auction-ended-pop-up.component';
import { AuctionWinnerPopUpComponent } from '../auction-winner-pop-up/auction-winner-pop-up.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-auction-config',
  templateUrl: './admin-auction-config.component.html',
  styleUrls: ['./admin-auction-config.component.css']
})
export class AdminAuctionConfigComponent implements OnInit {
  @Input() auctionStatus: any;
  @Input() startDateTimer: any;
  @Input() endDateTimer: any;
  @Input() number: any;
  @Input() auctionData: any;
  @Input() lastbid: any;
  @Input() LastBidder: any;
  @Input() bidders: any;
  @Input() timeExtended: any;
  @Output() reloadPage = new EventEmitter<any>();
  @Output() AuctionEnded = new EventEmitter<any>();
  remaining = true;
  intervalRemaining: any;
  afterTowHours = false;
  publishLoad = false;
  dataConfirmActions: any;
  countdownEndTime: any;
  countdownString: any;
  loadingBtnRequest: boolean = false;
  showConfirmSold: boolean = false;
  subscriptions: Subscription[] = [];

  TotalCounts: number = 60;
  currentCount: number = 30;
  constructor(
    private dialog: MatDialog,
    public _config: ConfigService,
    private _auctions: AuctionsService,
    public socket: SocketService

  ) {



  }

  ngOnInit() {
    console.log(this.auctionData?.remaining_time);
    // const currentTime = moment('YYYY-MM-DD HH:mm:ss');
    // const startTime = moment(this.auctionData.startDateTimer);
    // const diffInMinutes = currentTime.valueOf() - startTime.valueOf()
    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed) {
    //   this.timer()
    // }

    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed) {
    //   this.checkShowConfirmSold();
    // }

    if (this.auctionStatus == 'ongoing') {
      this.getRemainingSocket();
    }
  }
  ngOnChanges(changes: any): void {
    console.log(this.auctionData.remaining_time);
  }
  when30SecondsEnded(event: any) {

    if (this.TotalCounts > 0 && event) {
      this.currentCount = 30 + Math.random();
      this.TotalCounts = this.TotalCounts - 30;
    }

  }
  onEditAuction() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(CreateAuctionComponent, {
      width: 'auto',
      minWidth: "400px",
      data: {
        auctionId: this.auctionData.id,
        room_id: this.auctionData.room.id,
        btnSubmit: this._config.translate.instant("Auctions.save"),
        Title: this._config.translate.instant("Auctions.Update Item")
      },
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res === true) {
        this.reloadPage.emit()
      }
    })
  }

  startAuction() {
    this.dataConfirmActions = {
      title: this._config.translate.instant("Auction Item.Start Auction"),
      icon: 'warning',
      text: this._config.translate.instant("Auction Item.AreYouSureStart"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
      auctionId: this.auctionData.id
    };

    const dialogRef = this.dialog.open(StartAuctionComponent, {
      data: this.dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {


      if (res == 'success') {
        this.reloadPage.emit();
      }


    });


  }

  publishAuction(status: number) {
    this.dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
      data: { auctionId: this.auctionData.id, room_id: this.auctionData.room.id, is_published: status },
    };
    const dialogRef = this.dialog.open(ChangeStatusComponent, {
      data: this.dataConfirmActions,
      panelClass: 'customDialogStyle'
    });
    dialogRef.afterClosed().subscribe((res) => {


      if (res == 'success') {
        this.reloadPage.emit(true);
      }


    });
  }
  onEndAuction() {
    this.dataConfirmActions = {
      title: this._config.translate.instant("Auction Item.Start Auction"),
      icon: 'warning',
      text: this._config.translate.instant("Auction Item.AreYouSureStart"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
      auctionId: this.auctionData.id
    };

    const dialogRef = this.dialog.open(EndAuctionComponent, {
      width: "auto",
      data: this.dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {


      if (res == 'success') {
        this.reloadPage.emit();
      }


    });

  }

  getRemainingSocket() {
    this.subscriptions.push(
      this.socket.getDataStream<string>("getRemaining" + this.auctionData.id)
        .subscribe(message => {


          this.auctionData.remaining_time = message.data.response;

          if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && message.data.response <= 300) {
            this.showConfirmSold = true;
          }


          if (message.data.response == 0) {
            this.OnReload('ongoing');
          }

        })
    )
  }

  DeleteAuction() {
    const dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this._auctions.DeleteAuction(this.auctionData.id).subscribe({
          next: (data) => {
            this._config.toastrService.success(data.message)
            this._config.goTo("/rooms/detailes/" + this.auctionData.room.id)
          },
          error: (err) => {
            this._config.showErrors(err)
          }
        })

      }
    })
  }
  checkShowConfirmSold() {
    // const currentTime = moment().unix();
    // const fiveMinutesAgo = moment(this.endDateTimer).subtract(5, 'minutes').unix();
    // setInterval(() => {
    //   const currentTime = moment().unix();
    //   const fiveMinutesAgo = moment(this.endDateTimer).subtract(5, 'minutes').unix();


    //   if (currentTime > fiveMinutesAgo) {
    //     this.showConfirmSold = true;
    //   }
    // }, 500);
    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed) {
    //   this.showConfirmSold = true;
    // }
  }
  // startAuction() {
  //   this.dataConfirmActions = {
  //     title: this._config.translate.instant("Auction Item.Start Auction"),
  //     icon: 'warning',
  //     text: this._config.translate.instant("Auction Item.AreYouSureStart"),
  //     confirm: this._config.translate.instant("actions.confirm"),
  //     cancel: this._config.translate.instant("actions.cancel"),
  //   };

  //   const dialogRef = this.dialog.open(ConfirmComponent, {
  //     data: this.dataConfirmActions,
  //     panelClass: 'customDialogStyle'
  //   });

  //   dialogRef.afterClosed().subscribe((res) => {

  //     if (res == 'success') {
  //       this._auctions.startAuction(this.auctionData.id).subscribe({
  //         next: (data: any) => {
  //           this._config.toastrService.success(data.message);
  //           this.reloadPage.emit('success');
  //         }, error: (error: any) => {
  //           error.errors.forEach((err: any) => {
  //             this._config.toastrService.error(err.massage);
  //           });
  //         }
  //       });

  //     }


  //   });
  // }


  // timer() {
  //   // set the countdown end time
  //   this.countdownEndTime = moment(this.auctionData.end_date).add(2, 'hours');
  //   this.countDown();
  //   // update the countdown every second
  //   setInterval(() => {
  //     this.countDown();

  //   }, 1000);
  // }


  // countDown() {

  //   const timeRemaining = this.countdownEndTime.diff(moment());

  //   // check if the countdown has ended
  //   if (timeRemaining <= 0) {
  //     this.countdownString = "Countdown ended!";
  //     return;
  //   }

  //   // calculate the hours, minutes, and seconds remaining using Moment.js
  //   const duration = moment.duration(timeRemaining);
  //   const hours = duration.hours();
  //   const minutes = duration.minutes();
  //   const seconds = duration.seconds();

  //   // format the time remaining as astring
  //   this.countdownString = hours + " hr : " + minutes + " mins : " + seconds + " secs";
  // }

  AdminConfirmSolid() {
    const dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.loadingBtnRequest = true;
        this._auctions.endAuctionWithWinner(this.auctionData.id).subscribe({
          next: (data: any) => {
            // const auctionInfo = {
            //   auctionId: this.auctionData.id
            // }
            // this.socket.socket.emit("reloadPage", auctionInfo);
            this.reloadPage.emit();

            this.loadingBtnRequest = false;
            // location.reload();
            this._config.toastrService.success(data.message);
          }, error: (error: any) => {
            this.loadingBtnRequest = false;
            this._config.showErrors(error)
          }
        });

      }
    })
  }

  AdminEndAuctionWithNoWinner() {
    const dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.loadingBtnRequest = true;
        this._auctions.endAuctionWithoutWinner(this.auctionData.id).subscribe({
          next: (data: any) => {
            // const auctionInfo = {
            //   auctionId: this.auctionData.id
            // }
            // this.socket.socket.emit("reloadPage", auctionInfo);
            this.reloadPage.emit();

            this.loadingBtnRequest = false;
            this._config.toastrService.success(data.message);
          }, error: (error: any) => {
            this.loadingBtnRequest = false;
            this._config.showErrors(error)
          }
        });

      }
    })
  }

  getRemaining() {

    // console.log(event);

    // this.auctionData.remaining_time = event;

    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed) {
    //   this.showConfirmSold = true;
    // }
    // if (this.remaining && this.auctionData.remaining_time < 60 && this.auctionStatus == "ongoing") {
    //   this.remaining = false;
    //   this.intervalRemaining = setInterval(() => {
    //     this.socket?.socket?.emit("getRemaining", this.auctionData.id);
    //   }, 2000)



    // }

  }

  OnReload(status: string) {
    // debugger
    if (status == 'upcoming') {
      this.auctionStatus = 'ongoing';
      this.auctionData.remaining_time = moment(this.auctionData?.end_date).unix() - moment(this.auctionData?.start_date).unix();
      this.getRemainingSocket();
    } else {
      this.auctionStatus = 'end';
      this.AuctionEnded.emit(true);
      clearInterval(this.intervalRemaining);
    }
  }

}
